var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-layout-item circle-tab-root" },
    [
      _c(
        "div",
        { staticClass: "desktop-tabs" },
        [
          _c(
            "md-tabs",
            { attrs: { "md-dynamic-height": "" } },
            [
              _c(
                "md-tab",
                { attrs: { id: "tab-details", "md-label": "Details" } },
                [
                  _c(
                    "md-field",
                    { staticClass: "mb-0" },
                    [
                      _c(
                        "label",
                        { staticClass: "md-list-item-text circle-label" },
                        [_vm._v("Circle Name")]
                      ),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        ref: "nameInput-{{ circle.short }}",
                        attrs: {
                          name: "circle_name-" + _vm.idx,
                          "data-vv-as": "Circle Name",
                          placeholder: "Circle Name",
                          disabled: !_vm.circle.editing
                        },
                        model: {
                          value: _vm.circle.name,
                          callback: function($$v) {
                            _vm.$set(_vm.circle, "name", $$v)
                          },
                          expression: "circle.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("circle_name-" + _vm.idx),
                          expression: "errors.has(`circle_name-${idx}`)"
                        }
                      ],
                      staticClass: "error error-font"
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.errors.first("circle_name-" + _vm.idx))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    {
                      staticClass:
                        "md-field md-theme-default md-disabled md-required md-has-value md-has-placeholder"
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "md-list-item-text circle-label" },
                        [_vm._v("Circle Code")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-input" }, [
                        _vm._v(_vm._s(_vm.circle.short))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    {
                      staticClass:
                        "md-field md-theme-default md-disabled md-required md-has-value md-has-placeholder"
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "md-list-item-text circle-label" },
                        [_vm._v("Circle Page URL")]
                      ),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_]*)?$/
                            },
                            expression:
                              "{ required: true, regex: /^http(s?)\\:\\/\\/[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(\\/?)([a-zA-Z0-9\\-\\.\\?\\,\\'\\/\\\\\\+&%\\$#_]*)?$/ }"
                          }
                        ],
                        attrs: {
                          name: "circle_page_url-" + _vm.idx,
                          "data-vv-as": "Circle Page URL",
                          placeholder: "https://xxx.protopia.co",
                          disabled: !_vm.circle.editing
                        },
                        on: {
                          input: function($event) {
                            _vm.circle.circlePageUrl = _vm.ensureHttpsScheme(
                              _vm.sanitizeUrl($event)
                            )
                          }
                        },
                        model: {
                          value: _vm.circle.circlePageUrl,
                          callback: function($$v) {
                            _vm.$set(_vm.circle, "circlePageUrl", $$v)
                          },
                          expression: "circle.circlePageUrl"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("circle_page_url-" + _vm.idx),
                          expression: "errors.has(`circle_page_url-${idx}`)"
                        }
                      ],
                      staticClass: "error error-font"
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.errors.first("circle_page_url-" + _vm.idx))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    {
                      staticClass:
                        "md-field md-theme-default md-disabled md-required md-has-value md-has-placeholder"
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "md-list-item-text circle-label" },
                        [_vm._v("Action Page")]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-select",
                        {
                          attrs: { disabled: !_vm.circle.editing },
                          model: {
                            value: _vm.circle.actionPage,
                            callback: function($$v) {
                              _vm.$set(_vm.circle, "actionPage", $$v)
                            },
                            expression: "circle.actionPage"
                          }
                        },
                        [
                          _c(
                            "md-option",
                            { attrs: { value: null, disabled: "" } },
                            [_vm._v("Select an option")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.actionPageOptions, function(page) {
                            return _c(
                              "md-option",
                              { key: page.code, attrs: { value: page.code } },
                              [_vm._v(_vm._s(page.name))]
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    {
                      staticClass:
                        "md-field md-theme-default md-disabled md-required md-has-value md-has-placeholder"
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "md-list-item-text circle-label" },
                        [_vm._v("Administrators")]
                      ),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: {
                          name: "circle administrators",
                          placeholder: "Add Administrators",
                          disabled: !_vm.circle.editing
                        },
                        model: {
                          value: _vm.circle.administrators,
                          callback: function($$v) {
                            _vm.$set(_vm.circle, "administrators", $$v)
                          },
                          expression: "circle.administrators"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    {
                      staticClass:
                        "no-underline md-field md-theme-default md-disabled md-required md-has-value md-has-placeholder"
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "md-list-item-text circle-label" },
                        [_vm._v("Affinities")]
                      ),
                      _vm._v(" "),
                      _c("md-chips", {
                        attrs: {
                          "md-static": !_vm.circle.editing,
                          "md-clickable": _vm.circle.editing,
                          placeholder: "Add Affinities..."
                        },
                        model: {
                          value: _vm.circle.interests,
                          callback: function($$v) {
                            _vm.$set(_vm.circle, "interests", $$v)
                          },
                          expression: "circle.interests"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-tab",
                { attrs: { id: "tab-subject", "md-label": "Subjects" } },
                [
                  _c(
                    "div",
                    { staticClass: "scrollable-tab" },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "add-btn",
                          attrs: { disabled: !_vm.circle.editing },
                          on: {
                            click: function($event) {
                              return _vm.openAddDialog("subject")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        + Add " +
                              _vm._s(this.wizardLabels.subject) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.circle.subjects, function(subject, sIdx) {
                        return _c(
                          "md-field",
                          { key: "subject-" + sIdx },
                          [
                            _c(
                              "label",
                              { staticClass: "md-list-item-text circle-label" },
                              [_vm._v("Subject " + _vm._s(sIdx + 1))]
                            ),
                            _vm._v(" "),
                            _c("md-input", {
                              attrs: {
                                name: "wizard_subjects",
                                placeholder: "Add Subject",
                                disabled: !_vm.circle.editing,
                                "md-counter": _vm.limits.subjects.max,
                                maxlength: _vm.limits.subjects.max
                              },
                              on: {
                                input: function($event) {
                                  _vm.circle.subjects[
                                    sIdx
                                  ] = _vm.sanitizeCustomizations(
                                    _vm.circle.subjects[sIdx]
                                  )
                                }
                              },
                              model: {
                                value: _vm.circle.subjects[sIdx],
                                callback: function($$v) {
                                  _vm.$set(_vm.circle.subjects, sIdx, $$v)
                                },
                                expression: "circle.subjects[sIdx]"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "md-button",
                              {
                                staticClass: "remove-btn",
                                attrs: {
                                  iconable: "",
                                  disabled: !_vm.circle.editing
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeItem("subject", sIdx)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-trash small-icon",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "md-tooltip",
                                  {
                                    staticClass: "tooltip-text",
                                    attrs: { "md-direction": "top" }
                                  },
                                  [_vm._v("Remove Subject")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "md-tab",
                { attrs: { id: "tab-intros", "md-label": "Introductions" } },
                [
                  _c(
                    "div",
                    { staticClass: "scrollable-tab" },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "add-btn",
                          attrs: { disabled: !_vm.circle.editing },
                          on: {
                            click: function($event) {
                              return _vm.openAddDialog("intro")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        + Add " +
                              _vm._s(this.wizardLabels.intro) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.circle.intros, function(intro, iIdx) {
                        return _c(
                          "md-field",
                          { key: "intro-" + iIdx },
                          [
                            _c(
                              "label",
                              { staticClass: "md-list-item-text circle-label" },
                              [_vm._v("Introduction " + _vm._s(iIdx + 1))]
                            ),
                            _vm._v(" "),
                            _c("md-textarea", {
                              attrs: {
                                name: "wizard_intros",
                                placeholder: "Add Intro",
                                disabled: !_vm.circle.editing,
                                "md-counter": _vm.limits.intros.max,
                                maxlength: _vm.limits.intros.max
                              },
                              on: {
                                input: function($event) {
                                  _vm.circle.intros[
                                    iIdx
                                  ] = _vm.sanitizeCustomizations(
                                    _vm.circle.intros[iIdx]
                                  )
                                }
                              },
                              model: {
                                value: _vm.circle.intros[iIdx],
                                callback: function($$v) {
                                  _vm.$set(_vm.circle.intros, iIdx, $$v)
                                },
                                expression: "circle.intros[iIdx]"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "md-button",
                              {
                                staticClass: "remove-btn",
                                attrs: {
                                  iconable: "",
                                  disabled: !_vm.circle.editing
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeItem("intro", iIdx)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-trash small-icon",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "md-tooltip",
                                  {
                                    staticClass: "tooltip-text",
                                    attrs: { "md-direction": "top" }
                                  },
                                  [_vm._v("Remove Introduction")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "md-tab",
                { attrs: { id: "tab-questions", "md-label": "Questions" } },
                [
                  _c(
                    "div",
                    { staticClass: "scrollable-tab" },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "add-btn",
                          attrs: { disabled: !_vm.circle.editing },
                          on: {
                            click: function($event) {
                              return _vm.openAddDialog("question")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        + Add " +
                              _vm._s(this.wizardLabels.question) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.circle.questions, function(question, qIdx) {
                        return _c(
                          "md-field",
                          { key: "question-" + qIdx },
                          [
                            _c(
                              "label",
                              { staticClass: "md-list-item-text circle-label" },
                              [_vm._v("Question " + _vm._s(qIdx + 1))]
                            ),
                            _vm._v(" "),
                            _c("md-textarea", {
                              attrs: {
                                name: "wizard_questions",
                                placeholder: "Add question",
                                disabled: !_vm.circle.editing,
                                "md-counter": _vm.limits.questions.max,
                                maxlength: _vm.limits.questions.max
                              },
                              model: {
                                value: _vm.circle.questions[qIdx],
                                callback: function($$v) {
                                  _vm.$set(_vm.circle.questions, qIdx, $$v)
                                },
                                expression: "circle.questions[qIdx]"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "md-button",
                              {
                                staticClass: "remove-btn",
                                attrs: {
                                  iconable: "",
                                  disabled: !_vm.circle.editing
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeItem("question", qIdx)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-trash small-icon",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "md-tooltip",
                                  {
                                    staticClass: "tooltip-text",
                                    attrs: { "md-direction": "top" }
                                  },
                                  [_vm._v("Remove Question")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "md-tab",
                { attrs: { id: "tab-thankyou", "md-label": "Thank you" } },
                [
                  _c(
                    "div",
                    { staticClass: "scrollable-tab" },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "add-btn",
                          attrs: { disabled: !_vm.circle.editing },
                          on: {
                            click: function($event) {
                              return _vm.openAddDialog("thankyou")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        + Add " +
                              _vm._s(this.wizardLabels.thankyou) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.circle.thankyou, function(thanks, tIdx) {
                        return _c(
                          "md-field",
                          { key: "thanks-" + tIdx },
                          [
                            _c(
                              "label",
                              { staticClass: "md-list-item-text circle-label" },
                              [_vm._v("Thank you " + _vm._s(tIdx + 1))]
                            ),
                            _vm._v(" "),
                            _c("md-textarea", {
                              attrs: {
                                name: "wizard_thankyou",
                                placeholder: "Add thank you",
                                disabled: !_vm.circle.editing,
                                "md-counter": _vm.limits.thankyou.max,
                                maxlength: _vm.limits.thankyou.max
                              },
                              model: {
                                value: _vm.circle.thankyou[tIdx],
                                callback: function($$v) {
                                  _vm.$set(_vm.circle.thankyou, tIdx, $$v)
                                },
                                expression: "circle.thankyou[tIdx]"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "md-button",
                              {
                                staticClass: "remove-btn",
                                attrs: {
                                  iconable: "",
                                  disabled: !_vm.circle.editing
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeItem("thankyou", tIdx)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-trash small-icon",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "md-tooltip",
                                  {
                                    staticClass: "tooltip-text",
                                    attrs: { "md-direction": "top" }
                                  },
                                  [_vm._v("Remove Thank You")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "md-tab",
                { attrs: { id: "tab-prompts", "md-label": "Prompts" } },
                [
                  _c(
                    "div",
                    { staticClass: "scrollable-tab" },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "add-btn",
                          attrs: { disabled: !_vm.circle.editing },
                          on: {
                            click: function($event) {
                              return _vm.openAddDialog("prompt")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        + Add " +
                              _vm._s(this.wizardLabels.prompt) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.circle.prompts, function(prompt, pIdx) {
                        return _c(
                          "md-field",
                          { key: "prompt-" + pIdx },
                          [
                            _c(
                              "label",
                              { staticClass: "md-list-item-text circle-label" },
                              [_vm._v("Prompt " + _vm._s(pIdx + 1))]
                            ),
                            _vm._v(" "),
                            _c("md-textarea", {
                              attrs: {
                                name: "wizard_prompts",
                                placeholder: "Add prompt",
                                disabled: !_vm.circle.editing,
                                "md-counter": _vm.limits.prompts.max,
                                maxlength: _vm.limits.prompts.max
                              },
                              model: {
                                value: _vm.circle.prompts[pIdx],
                                callback: function($$v) {
                                  _vm.$set(_vm.circle.prompts, pIdx, $$v)
                                },
                                expression: "circle.prompts[pIdx]"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "md-button",
                              {
                                staticClass: "remove-btn",
                                attrs: {
                                  iconable: "",
                                  disabled: !_vm.circle.editing
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeItem("prompt", pIdx)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-trash small-icon",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "md-tooltip",
                                  {
                                    staticClass: "tooltip-text",
                                    attrs: { "md-direction": "top" }
                                  },
                                  [_vm._v("Remove Prompt")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mobile-tabs" },
        [
          _c(
            "md-list",
            { attrs: { "md-expand-single": true } },
            [
              _c(
                "md-list-item",
                { attrs: { "md-expand": "", "md-expanded": "" } },
                [
                  _c("div", { staticClass: "md-list-item-text" }, [
                    _vm._v("Details")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "item-list-text",
                      attrs: { slot: "md-expand" },
                      slot: "md-expand"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            { staticClass: "md-list-item-text circle-label" },
                            [_vm._v("Circle Name")]
                          ),
                          _vm._v(" "),
                          _c("md-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            ref: "nameInput-{{ circle.short }}",
                            attrs: {
                              name: "circle_name-" + _vm.idx,
                              "data-vv-as": "Circle Name",
                              placeholder: "Circle Name",
                              disabled: !_vm.circle.editing
                            },
                            model: {
                              value: _vm.circle.name,
                              callback: function($$v) {
                                _vm.$set(_vm.circle, "name", $$v)
                              },
                              expression: "circle.name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("circle_name-" + _vm.idx),
                              expression: "errors.has(`circle_name-${idx}`)"
                            }
                          ],
                          staticClass: "error error-font"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.errors.first("circle_name-" + _vm.idx)
                              ) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("md-field", [
                        _c(
                          "label",
                          { staticClass: "md-list-item-text circle-label" },
                          [_vm._v("Circle Code")]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "md-input" }, [
                          _vm._v(_vm._s(_vm.circle.short))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        {
                          class: { "md-has-value": !!_vm.circle.circlePageUrl }
                        },
                        [
                          _c(
                            "label",
                            { staticClass: "md-list-item-text circle-label" },
                            [_vm._v("Circle Page URL")]
                          ),
                          _vm._v(" "),
                          _c("md-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_]*)?$/
                                },
                                expression:
                                  "{ required: true, regex: /^http(s?)\\:\\/\\/[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(\\/?)([a-zA-Z0-9\\-\\.\\?\\,\\'\\/\\\\\\+&%\\$#_]*)?$/ }"
                              }
                            ],
                            attrs: {
                              name: "circle_page_url-" + _vm.idx,
                              "data-vv-as": "Circle Page URL",
                              placeholder: "https://xxx.protopia.co",
                              disabled: !_vm.circle.editing
                            },
                            on: {
                              input: function($event) {
                                _vm.circle.circlePageUrl = _vm.ensureHttpsScheme(
                                  _vm.sanitizeUrl($event)
                                )
                              }
                            },
                            model: {
                              value: _vm.circle.circlePageUrl,
                              callback: function($$v) {
                                _vm.$set(_vm.circle, "circlePageUrl", $$v)
                              },
                              expression: "circle.circlePageUrl"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has(
                                "circle_page_url-" + _vm.idx
                              ),
                              expression: "errors.has(`circle_page_url-${idx}`)"
                            }
                          ],
                          staticClass: "error error-font"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.errors.first("circle_page_url-" + _vm.idx)
                              ) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        [
                          _c(
                            "label",
                            { staticClass: "md-list-item-text circle-label" },
                            [_vm._v("Action Page")]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-select",
                            {
                              attrs: { disabled: !_vm.circle.editing },
                              model: {
                                value: _vm.circle.actionPage,
                                callback: function($$v) {
                                  _vm.$set(_vm.circle, "actionPage", $$v)
                                },
                                expression: "circle.actionPage"
                              }
                            },
                            [
                              _c(
                                "md-option",
                                { attrs: { value: null, disabled: "" } },
                                [_vm._v("Select an option")]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.actionPageOptions, function(page) {
                                return _c(
                                  "md-option",
                                  {
                                    key: page.code,
                                    attrs: { value: page.code }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(page.name) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        [
                          _c(
                            "label",
                            { staticClass: "md-list-item-text circle-label" },
                            [_vm._v("Administrators")]
                          ),
                          _vm._v(" "),
                          _c("md-input", {
                            attrs: {
                              name: "circle administrators",
                              placeholder: "Add Administrators",
                              disabled: !_vm.circle.editing
                            },
                            model: {
                              value: _vm.circle.administrators,
                              callback: function($$v) {
                                _vm.$set(_vm.circle, "administrators", $$v)
                              },
                              expression: "circle.administrators"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        { staticClass: "no-underline" },
                        [
                          _c(
                            "label",
                            { staticClass: "md-list-item-text circle-label" },
                            [_vm._v("Affinities")]
                          ),
                          _vm._v(" "),
                          _c("md-chips", {
                            attrs: {
                              "md-static": !_vm.circle.editing,
                              "md-clickable": _vm.circle.editing,
                              placeholder: "Add Affinities..."
                            },
                            model: {
                              value: _vm.circle.interests,
                              callback: function($$v) {
                                _vm.$set(_vm.circle, "interests", $$v)
                              },
                              expression: "circle.interests"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("md-list-item", { attrs: { "md-expand": "" } }, [
                _c("div", { staticClass: "md-list-item-text" }, [
                  _vm._v("Subjects")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-list-text",
                    attrs: { slot: "md-expand" },
                    slot: "md-expand"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "scrollable-tab" },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "add-btn",
                            attrs: { disabled: !_vm.circle.editing },
                            on: {
                              click: function($event) {
                                return _vm.openAddDialog("subject")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            + Add " +
                                _vm._s(_vm.wizardLabels.subject) +
                                "\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.circle.subjects, function(subject, sIdx) {
                          return _c(
                            "md-field",
                            { key: "subject-" + sIdx },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "md-list-item-text circle-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                Subject " +
                                      _vm._s(sIdx + 1) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  name: "wizard_subjects",
                                  placeholder: "Add Subject",
                                  disabled: !_vm.circle.editing,
                                  "md-counter": _vm.limits.subjects.max,
                                  maxlength: _vm.limits.subjects.max
                                },
                                on: {
                                  input: function($event) {
                                    _vm.circle.subjects[
                                      sIdx
                                    ] = _vm.sanitizeCustomizations(
                                      _vm.circle.subjects[sIdx]
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.circle.subjects[sIdx],
                                  callback: function($$v) {
                                    _vm.$set(_vm.circle.subjects, sIdx, $$v)
                                  },
                                  expression: "circle.subjects[sIdx]"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  staticClass: "remove-btn",
                                  attrs: {
                                    iconable: "",
                                    disabled: !_vm.circle.editing
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeItem("subject", sIdx)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-trash small-icon",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "md-tooltip",
                                    {
                                      staticClass: "tooltip-text",
                                      attrs: { "md-direction": "top" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Remove Subject\n                                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("md-list-item", { attrs: { "md-expand": "" } }, [
                _c("div", { staticClass: "md-list-item-text" }, [
                  _vm._v("Introductions")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-list-text",
                    attrs: { slot: "md-expand" },
                    slot: "md-expand"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "scrollable-tab" },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "add-btn",
                            attrs: { disabled: !_vm.circle.editing },
                            on: {
                              click: function($event) {
                                return _vm.openAddDialog("intro")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            + Add " +
                                _vm._s(_vm.wizardLabels.intro) +
                                "\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.circle.intros, function(intro, iIdx) {
                          return _c(
                            "md-field",
                            { key: "intro-" + iIdx },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "md-list-item-text circle-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                Introduction " +
                                      _vm._s(iIdx + 1) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("md-textarea", {
                                attrs: {
                                  name: "wizard_intros",
                                  placeholder: "Add Intro",
                                  disabled: !_vm.circle.editing,
                                  "md-counter": _vm.limits.intros.max,
                                  maxlength: _vm.limits.intros.max
                                },
                                on: {
                                  input: function($event) {
                                    _vm.circle.intros[
                                      iIdx
                                    ] = _vm.sanitizeCustomizations(
                                      _vm.circle.intros[iIdx]
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.circle.intros[iIdx],
                                  callback: function($$v) {
                                    _vm.$set(_vm.circle.intros, iIdx, $$v)
                                  },
                                  expression: "circle.intros[iIdx]"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  staticClass: "remove-btn",
                                  attrs: {
                                    iconable: "",
                                    disabled: !_vm.circle.editing
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeItem("intro", iIdx)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-trash small-icon",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "md-tooltip",
                                    {
                                      staticClass: "tooltip-text",
                                      attrs: { "md-direction": "top" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Remove Introduction\n                                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("md-list-item", { attrs: { "md-expand": "" } }, [
                _c("div", { staticClass: "md-list-item-text" }, [
                  _vm._v("Questions")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-list-text",
                    attrs: { slot: "md-expand" },
                    slot: "md-expand"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "scrollable-tab" },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "add-btn",
                            attrs: { disabled: !_vm.circle.editing },
                            on: {
                              click: function($event) {
                                return _vm.openAddDialog("question")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            + Add " +
                                _vm._s(_vm.wizardLabels.question) +
                                "\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.circle.questions, function(question, qIdx) {
                          return _c(
                            "md-field",
                            { key: "question-" + qIdx },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "md-list-item-text circle-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                Question " +
                                      _vm._s(qIdx + 1) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("md-textarea", {
                                attrs: {
                                  name: "wizard_questions",
                                  placeholder: "Add question",
                                  disabled: !_vm.circle.editing,
                                  "md-counter": _vm.limits.questions.max,
                                  maxlength: _vm.limits.questions.max
                                },
                                model: {
                                  value: _vm.circle.questions[qIdx],
                                  callback: function($$v) {
                                    _vm.$set(_vm.circle.questions, qIdx, $$v)
                                  },
                                  expression: "circle.questions[qIdx]"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  staticClass: "remove-btn",
                                  attrs: {
                                    iconable: "",
                                    disabled: !_vm.circle.editing
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeItem("question", qIdx)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-trash small-icon",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "md-tooltip",
                                    {
                                      staticClass: "tooltip-text",
                                      attrs: { "md-direction": "top" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Remove Question\n                                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("md-list-item", { attrs: { "md-expand": "" } }, [
                _c("div", { staticClass: "md-list-item-text" }, [
                  _vm._v("Thank you")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-list-text",
                    attrs: { slot: "md-expand" },
                    slot: "md-expand"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "scrollable-tab" },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "add-btn",
                            attrs: { disabled: !_vm.circle.editing },
                            on: {
                              click: function($event) {
                                return _vm.openAddDialog("thankyou")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            + Add " +
                                _vm._s(_vm.wizardLabels.thankyou) +
                                "\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.circle.thankyou, function(thanks, tIdx) {
                          return _c(
                            "md-field",
                            { key: "thanks-" + tIdx },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "md-list-item-text circle-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                Thank you " +
                                      _vm._s(tIdx + 1) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("md-textarea", {
                                attrs: {
                                  name: "wizard_thankyou",
                                  placeholder: "Add thank you",
                                  disabled: !_vm.circle.editing,
                                  "md-counter": _vm.limits.thankyou.max,
                                  maxlength: _vm.limits.thankyou.max
                                },
                                model: {
                                  value: _vm.circle.thankyou[tIdx],
                                  callback: function($$v) {
                                    _vm.$set(_vm.circle.thankyou, tIdx, $$v)
                                  },
                                  expression: "circle.thankyou[tIdx]"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  staticClass: "remove-btn",
                                  attrs: {
                                    iconable: "",
                                    disabled: !_vm.circle.editing
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeItem("thankyou", tIdx)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-trash small-icon",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "md-tooltip",
                                    {
                                      staticClass: "tooltip-text",
                                      attrs: { "md-direction": "top" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Remove Thank You\n                                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("md-list-item", { attrs: { "md-expand": "" } }, [
                _c("div", { staticClass: "md-list-item-text" }, [
                  _vm._v("Prompts")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-list-text",
                    attrs: { slot: "md-expand" },
                    slot: "md-expand"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "scrollable-tab" },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "add-btn",
                            attrs: { disabled: !_vm.circle.editing },
                            on: {
                              click: function($event) {
                                return _vm.openAddDialog("prompt")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            + Add " +
                                _vm._s(_vm.wizardLabels.prompt) +
                                "\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.circle.prompts, function(prompt, pIdx) {
                          return _c(
                            "md-field",
                            { key: "prompt-" + pIdx },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "md-list-item-text circle-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                Prompt " +
                                      _vm._s(pIdx + 1) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("md-textarea", {
                                attrs: {
                                  name: "wizard_prompts",
                                  placeholder: "Add prompt",
                                  disabled: !_vm.circle.editing,
                                  "md-counter": _vm.limits.prompts.max,
                                  maxlength: _vm.limits.prompts.max
                                },
                                model: {
                                  value: _vm.circle.prompts[pIdx],
                                  callback: function($$v) {
                                    _vm.$set(_vm.circle.prompts, pIdx, $$v)
                                  },
                                  expression: "circle.prompts[pIdx]"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  staticClass: "remove-btn",
                                  attrs: {
                                    iconable: "",
                                    disabled: !_vm.circle.editing
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeItem("prompt", pIdx)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-trash small-icon",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "md-tooltip",
                                    {
                                      staticClass: "tooltip-text",
                                      attrs: { "md-direction": "top" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Remove Prompt\n                                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("add-wizard-item", {
        ref: "addWizardItem",
        attrs: {
          visible: _vm.dialogVisible,
          label: _vm.dialogLabel,
          dialogType: _vm.dialogType
        },
        on: {
          "update:visible": function($event) {
            _vm.dialogVisible = $event
          },
          confirm: _vm.confirmAdd,
          cancel: function($event) {
            _vm.dialogVisible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-400caf9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-400caf9e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CircleTabs.vue
// module id = null
// module chunks = 